import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getWallet,
    getWallets,
    getWalletsReport
}

function getWallets(query = {}) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/wallets/all`)
            .set('access', Storage.getItem('access'))
            .query(query)
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getWalletsReport() {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/wallets/report`)
            .set('access', Storage.getItem('access'))
            .responseType('blob')
            .end((err, res) => {
                if(err)
                    resolve(null)
                else
                    resolve(res.body)
            })
    })
}

function getWallet(userId) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/wallets`)
           .set('access', Storage.getItem('access'))
           .query({userId})
           .end((err, res) => {
               resolve(res.body)
           })
    })
}